import {
    PsHttpService,
    type PatSnapCommonResponseData,
} from '@patsnap/tahiti-core/common/ps-http';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { eurekaApiUrlPrefix, agentApiUrlPrefix } from '@telecom/shared/domain-config';
import type { AgentApi, GenerateJobRequest, GenerateJobResponse } from './agent-api';

/**
 * IP 卡片项
 */
export interface IpCardItem {
    // 功能ID
    function_id: string;
    // 卡片名称
    name: string;
    // 描述
    description: string;
    // 目标
    goal: string;
    // 图片地址
    icon_url: string;
    // 类型：'A' = Agent, 'P' = Playbook
    type: 'A' | 'P';
    // Agent ID
    agent_id: string;
    // Team ID
    team_id: string;
    // 是否免费
    is_free: boolean;
    // 是否第三方
    is_third_party?: boolean;
}

/**
 * 获取 IP 卡片响应
 */
export interface GetIpCardsResponse {
    cards: IpCardItem[];
}

/**
 * Home IP API 接口
 */
export interface HomeIpApi {
    /**
     * 获取 IP 卡片列表
     */
    getIpCards(): Promise<GetIpCardsResponse>;

    /**
     * 获取 IP Profile 认证 token
     */
    getIpProfileToken(): Promise<string>;
}

export const HomeIpApi = Symbol('HomeIpApi');

/**
 * Home IP API 实现
 */
@injectable()
export class HomeIpApiImpl extends PsHttpService implements HomeIpApi, AgentApi {
    get options() {
        return {
            baseURL: eurekaApiUrlPrefix,
            headers: {
                'X-API-Version': '1.0',
            },
        };
    }

    getIpCards() {
        return this.get<PatSnapCommonResponseData<GetIpCardsResponse>>({
            url: 'ip-home-page/ip-cards',
            method: 'GET',
        }).then((res) => {
            return res?.data as unknown as GetIpCardsResponse;
        });
    }

    getIpProfileToken() {
        return this.get<PatSnapCommonResponseData<string>>({
            url: 'ip-home-page/ip-profile-token',
            method: 'GET',
        }).then((res) => {
            return res?.data as string;
        });
    }

    chatJob(data: GenerateJobRequest) {
        return this.post<PatSnapCommonResponseData<GenerateJobResponse>>({
            baseURL: agentApiUrlPrefix,
            url: '/job/chat',
            headers:
                data.sensitive_ignore === true ? { 'x-sensitive-ignore': 'true' } : {},
            data,
        }).then((res) => {
            return res as unknown as GenerateJobResponse;
        });
    }
}
